import { render, staticRenderFns } from "./FormBuilderCollectionCrud.vue?vue&type=template&id=4105d683&"
import script from "./FormBuilderCollectionCrud.vue?vue&type=script&lang=js&"
export * from "./FormBuilderCollectionCrud.vue?vue&type=script&lang=js&"
import style0 from "./FormBuilderCollectionCrud.vue?vue&type=style&index=0&id=4105d683&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports